<body>
    <ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
    <div class="" *ngIf="!loading">
        <app-navbar></app-navbar>
        <router-outlet></router-outlet>
    </div>

    <div *ngIf="loading"><div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
</body>
